import { Divider, Stack, Typography } from "@mui/material"
import { ReactElement } from "react";
import LearningHeaderButton from "./learning-center/LearningHeaderButton";

interface Props {
    title: string;
    action?: ReactElement;
    banner?: string;
}

const PageHeader = ({ title, action, banner }: Props) => {
    return (
        <Stack>
            <Stack
                direction={{
                    xs: "column",
                    sm: "row"
                }}
                justifyContent="space-between"
                sx={{
                    padding: 2,
                }}
                spacing={2}
                alignItems="center"
            >
                <Typography variant="h2">
                    {title}
                </Typography>
                <Stack direction="row" spacing={1} alignItems="center">
                    <LearningHeaderButton />
                    {action ? action : null}
                </Stack>
            </Stack>
            <Divider />
            {banner ?
                <Stack
                    sx={{
                        position: "relative",
                        "&::before": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            height: 40,
                            background:
                                "linear-gradient(to bottom, rgba(0,0,0,.35) 0%, rgba(0,0,0,.15) 40%, transparent 100%)",
                            zIndex: 2,
                            pointerEvents: "none",
                        },
                    }}
                >
                    <Stack
                        height={{ xs: "150px", sm: "200px" }}
                        overflow="hidden"
                        sx={{
                            position: "relative",
                            zIndex: 1,
                        }}
                    >
                        <img
                            src={banner}
                            alt="banner"
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                display: "block",
                            }}
                        />
                    </Stack>
                </Stack>
                : null}
        </Stack>
    )
}

export default PageHeader;
